import { getEnvironmentNameFromHostname } from "core/utils/runtime-environment";
import ENV from "parog-web/config/environment";

/** Callback function used as DD init "beforeSend" hook
 * Its goal is to make all the query params of a URL logged by DD to avoid RGPD info leaks
 */
const maskResourceQueryParams = event => {
  if (!event.resource) return;

  // Build the URL object from the resource "url" string
  const url = new URL(event.resource.url);

  // Iterate over each query parameter and replace its value with "masked-value"
  url.searchParams.forEach((_value, key) => {
    url.searchParams.set(key, "masked-value");
  });

  event.resource.url = url.toString();
};

export async function initialize(): Promise<void> {
  const clientToken = ENV.DD_RUM_CLIENT_TOKEN;
  const applicationId = ENV.DD_RUM_APPLICATION_ID;

  // We need both clientToken and applicationId!
  if (!clientToken || !applicationId) return;

  const env = getEnvironmentNameFromHostname(window.location.hostname);

  // Whitelist envs with RUM
  const validEnvironments = ["local", "development", "master", "release"];
  if (!validEnvironments.includes(env)) return;

  // If we reach this point, we are in a valid RUM environment. Let's set it up
  const { datadogRum } = await import("@datadog/browser-rum");

  datadogRum.init({
    clientToken,
    applicationId,
    site: "datadoghq.eu",
    service: "wise",
    env,
    version: `${ENV.APP["version"]}`,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,

    // See https://docs.datadoghq.com/fr/data_security/real_user_monitoring/#mask-action-names
    enablePrivacyForActionName: true,

    defaultPrivacyLevel: "mask",
    storeContextsAcrossPages: true,
    beforeSend: event => {
      // Make sure the query params of resources are masked before sending them to DD
      maskResourceQueryParams(event);
      return true;
    }
  });
}

export default {
  initialize
};
